import { ROUTE, ROUTE_STUDIO, ROUTE_SUFFIX, ROUTE_GUARDED, ROUTE_PROMO } from './routes';
import { PATTERN } from './validation';
import { PROMO, PROMO_TYPE } from './promo';

export enum EMAIL {
    SUPPORT = 'help@camcontacts.com',
}

export enum URL {
    CAMCONTACTS_URL = 'https://www.camcontacts.com',
    CAMCONTACTS = '/',
    CAMCONTACTS_CONTACTS = '/contactus.html',
    CAMCONTACTS_HELP_REQUEST = '/helprequest.html',
    GOOGLE_CHROME = 'https://www.google.com/chrome/',
}

export const ATTRIBUTE = {
    TARGET_BLANK: { target: '_blank' },
    REL_EXTERNAL: { rel: 'external nofollow noopener noreferrer' },
};

export enum RESPONSE {
    UNAUTHORIZED = 'Invalid username or password. Please try again.',
    SERVER_ERROR = 'Something went wrong. Please try again.',
}

export enum RESPONSE_STATUS {
    PASSWORD_EXPIRED = 14,
    MANDATORY_TERMS = 15,
}

export enum ERROR {
    INVALID_FILE_TYPE = 'Invalid file type. Accepted file types:',
}

export const ALLOWED_FILE_TYPES = '.jpg, .jpeg, .png, .gif';

export const SITE_ID = '1';

export const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const TIME_CONSTANTS = {
    SECONDS_PER_MINUTE: 60,
    MINUTES_PER_HOUR: 60,
    SECONDS_PER_HOUR: 3600,
    HOURS_PER_DAY: 24,
};

export const DEFAULT_CURRENCY_CODE = 'USD';

export namespace WORKER {
    export const BROADCAST_CHANNEL_NAME = 'ccmn-websocket-channel';
    export const SHARED_WORKER_NAME = 'ccmn-shared-worker';

    export enum COMMAND {
        CONNECT = 'connect',
        DISCONNECT = 'disconnect',
        UPDATE = 'update',
    }

    export enum TYPE {
        MESSAGE = 'message',
        LOGOUT = 'logout',
    }
}

export { ROUTE, ROUTE_STUDIO, ROUTE_SUFFIX, ROUTE_GUARDED, PROMO_TYPE, PROMO, ROUTE_PROMO, PATTERN };
